import { render } from "./FakePass.vue?vue&type=template&id=67b2bbec"
import script from "./FakePass.vue?vue&type=script&lang=js"
export * from "./FakePass.vue?vue&type=script&lang=js"

import "../css/icon.css?vue&type=style&index=0&lang=css"
import "../css/style.css?vue&type=style&index=1&lang=css"
script.render = render

export default script